export class GetBrandInfo {
  static readonly type = '[Brand State] GetBrandInfo';
  constructor() { }
}

export class BrandStateReset {
  static readonly type = '[Brand State] BrandStateReset';
  constructor() { }
}
